<header class="e11-bg-skin-white e11-border-b e11-px-6 e11-py-4">
  <div class="app-header-content e11-flex e11-justify-between">
    <mobile-drawer-icon [mobileDrawerState]="mobileDrawerState" (mobileDrawerStateChange)="toggleMobileSideDrawer()"></mobile-drawer-icon>
    <app-nav-header *ngIf="!(isMobile$ | async)"></app-nav-header>
    <profile-dropdown></profile-dropdown>
  </div>
</header>
